import { Expose } from 'class-transformer';

export class User {
  @Expose()
  id: number;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  email: string;

  @Expose()
  description: string;

  @Expose()
  phone: string;

  @Expose()
  avatar: string;

  @Expose()
  avatarType: string;

  @Expose()
  password: string;

  @Expose()
  resetToken: string;

  @Expose()
  address: {
    addressLine: string;
    city: string;
    state: string;
    postCode: string;
    country: string;
  };

  @Expose()
  tfa: {
    enabled: boolean;
    secret: string;
    tmpSecret: string;
    dataURL: string;
    tfaURL: string;
  };

  @Expose()
  qlikUserId: string;

  @Expose()
  qlikUserDirectory: string;

  @Expose()
  roles: any[];

  @Expose()
  permissions: any[];

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
